<template>
    <NewHomeCard :card-type="cardType">
        <template #title>
            <div class="title-body flex justify-between items-center text-ink">
                {{ t("chat.wrapped.actionItems.title") }}
                <span class="h-10 min-w-10 flex items-center justify-center">
                    <span class="body-small text-ink-muted">{{ t("chat.wrapped.actionItems.topicCount", { count: actionItems.length }, actionItems.length) }}</span>
                </span>
            </div>
        </template>
        <template #content>
            <div class="space-y-2">
                <BaseLink
                    v-for="item in actionItems"
                    :key="item.hashid"
                    :href="`/coach/start/?wrapped_action_item=${item.hashid}&chat_source=home_wrapped`"
                    class="body text-left py-2.5 px-5 rounded-2xl transition-[background-color] flex gap-2 fs-mask bg-surface-sunken hover:bg-surface-hover"
                    :before="() => handleActionItemClick(item)">
                    <i class="bi bi-arrow-right text-ink-muted mt-1" aria-hidden="true"></i>
                    <div class="flex-1 min-w-0">
                        <span v-if="item.label" class="inline-block details text-ink-muted bg-surface-raised px-2 py-1 rounded mb-1">{{ item.label }}</span>
                        <p class="mb-0 line-clamp-2 text-ink">{{ item.topic }}</p>
                        <p class="details text-ink-muted mt-1 line-clamp-1">{{ t("chat.wrapped.actionItems.buildingOn", { strength: item.strength }) }}</p>
                    </div>
                </BaseLink>
            </div>
        </template>
    </NewHomeCard>
</template>

<script setup>
import BaseLink from "~vue/router/BaseLink.vue";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";

import NewHomeCard from "./NewHomeCard.vue";

const { actionItems, cardType } = defineProps({
    actionItems: { type: Array, required: true },
    cardType: { type: String, required: true },
});

const { t } = useI18n();

onMounted(() => logUserInteraction(AmplitudeEventNames.WRAPPED_ACTION_ITEMS_SHOWN, { topics: actionItems.map((item) => item.topic) }));

const handleActionItemClick = (item) => {
    return logUserInteraction(AmplitudeEventNames.HOMEPAGE_WRAPPED_ACTION_ITEM_CLICKED, { topic: item.topic, hashid: item.hashid, source: "momentum_card" });
};
</script>
